export default __webpack_public_path__ + "static/media/damir-bosnjak.0d48c914.jpg";